import React, { useMemo } from 'react';
import cx from 'classnames';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import JBImage from 'components/essentials/JBImage';
import ProductCardImageComingSoon from 'components/consumer/ProductCardStatic/ProductCardStaticUI/components/ProductCardImageComingSoon';
import { IMAGE_FLIP_ORIENTATION_VALUES } from 'commons/constants';
import { getProductURL } from '../utils';

const ProductImage = ({
  closeCart,
  containerClass,
  hasImageLink,
  product,
  ...props
}) => {
  const history = useHistory();

  const imageSrcSet = useMemo(
    () => (product?.imageURL ? { src: product.imageURL } : null),
    [product]
  );

  const imageLink = useMemo(() => {
    if (hasImageLink && product) {
      return getProductURL({
        productUrlKey: get(product, 'product.attributes_min.urlKey', ''),
        options: product.options,
        pickLater: product.pickLater,
      });
    }
    return undefined;
  }, [hasImageLink, product]);

  const shouldFlip = useMemo(() => {
    if (product) {
      const orientationOption = product.options.find(p =>
        p.optionTypeName.includes('Orientation')
      );

      const serializedOrientationValue = orientationOption?.name
        ?.toLowerCase()
        .split(' ')
        .join('_');
      // compute shouldFlip
      return IMAGE_FLIP_ORIENTATION_VALUES.includes(serializedOrientationValue);
    }
    return false;
  }, [product]);

  const redirectAndClose = url => {
    closeCart();
    setTimeout(() => {
      history.push(url);
    });
  };

  return (
    <div
      className={cx(
        'relative',
        containerClass ||
          "mr-6 rounded flex justify-center items-center border border-solid border-gray-light8 bg-gray-light7 w-24 sm:w-28 md:w-[unset] md:p-2 after:content-[''] after:block after:pb-[100%] cursor-pointer",
        {
          'scale-x-[-1]': shouldFlip,
        }
      )}
      {...(hasImageLink && imageLink
        ? {
            onClick: () => redirectAndClose(imageLink),
            role: 'button',
            tabIndex: '-1',
          }
        : {})}
    >
      {imageSrcSet ? (
        <JBImage
          lazy={false}
          alt=""
          {...imageSrcSet}
          {...props}
          className="object-contain"
        />
      ) : (
        <ProductCardImageComingSoon />
      )}
    </div>
  );
};

ProductImage.propTypes = {
  closeCart: PropTypes.func,
  containerClass: PropTypes.string,
  hasImageLink: PropTypes.bool,
  product: PropTypes.shape({
    id: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.object),
    pickLater: PropTypes.bool,
    imageURL: PropTypes.string,
  }),
};

export default ProductImage;
